import { ISettingsFields } from 'models/settings';

export enum SettingsActions {
  SetSettings = '[Settings] Set Settings',
  UpdateSettings = '[Settings] Update Settings',
  SetRouteTemplate = '[Settings] Set Route Template',
  SetAssignTemplate = '[Settings] Set Assign Template',
}

export type SetSettings = {
  type: SettingsActions.SetSettings;
  payload: { settings: ISettingsFields };
};

export type UpdateSettings = {
  type: SettingsActions.UpdateSettings;
  payload: { settings: ISettingsFields };
};

export type SetRouteTemplateId = {
  type: SettingsActions.SetRouteTemplate;
  payload: { routeTemplateId: number | null };
};

export type SetAssignTemplateId = {
  type: SettingsActions.SetAssignTemplate;
  payload: { assignTemplateId: number | null };
};

export const setSettings = (settings: ISettingsFields): SetSettings => {
  return {
    type: SettingsActions.SetSettings,
    payload: { settings },
  };
};

export const updateSettings = (settings: ISettingsFields): UpdateSettings => {
  return {
    type: SettingsActions.UpdateSettings,
    payload: { settings },
  };
};

export const setRouteTemplate = (routeTemplateId: number | null): SetRouteTemplateId => {
  return {
    type: SettingsActions.SetRouteTemplate,
    payload: { routeTemplateId },
  };
};

export const setAssignTemplate = (assignTemplateId: number | null): SetAssignTemplateId => {
  return {
    type: SettingsActions.SetAssignTemplate,
    payload: { assignTemplateId },
  };
};

export type SettingsTypes = SetSettings | UpdateSettings | SetRouteTemplateId | SetAssignTemplateId;
